




// import React, { useState } from "react";
// import Slider from 'react-slick'; // Importing Slick Slider component
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Arrow icons for custom navigation

// // Import images
// import navyaImage from '../img/aaaservices/WhatsApp Image 2024-12-27 at 4.19.57 PM.jpeg'; // Replace with actual path
// import arjunImage from '../img/aaaservices/Akhil.jfif'; // Replace with actual path
// import meeraImage from '../img/banner/01_NARESH_FRONTEND DEVELOPER.jpeg'; 
// import rahulImage from '../img/aaaservices/03_RAMACHANDRA_BACKEND DEVELOPER.jpeg';
// import rahulImage1 from '../img/aaaservices/04_VIKASH_WEB DEVELOPER.jpeg'; // Replace with actual path
// import rahulImage2 from '../img/aaaservices/05_VIKASH SINGH_WEB DEVELOPER.jpeg'; // Replace with actual path
// import rahulImage3 from '../img/aaaservices/01_SHIVA.jpeg'; 
// import rahulImage4 from '../img/aaaservices/02_ANVESH.jpeg'; // Replace with actual path
// import rahulImage5 from '../img/aaaservices/03_PRASANNA.jpeg'; // Replace with actual path
// import rahulImage6 from '../img/aaaservices/04_WASIQ.jpeg'; // Replace with actual path
// import rahulImage7 from '../img/aaaservices/10_ LINGESWAR RAO.jpg'; // Replace with actual path
// import rahulImage8 from '../img/aaaservices/09_ (2).jpg'; // Replace with actual path
// import rahulImage9 from '../img/aaaservices/12_SARANYA.jpg'; // Replace with actual path
// import rahulImage10 from '../img/aaaservices/09_ SRIVASTHAV.jpg'; // Replace with actual path

// import logoImage from '../img/banner/Picture2.png';
// const CardComponent = () => {
//   const cards = [
//     {
//       id: 1,
//       name: 'Virtual Robotic Simulation',
//       rating: '★★★★★',
//       description: 'The training gave me hands-on experience in robotics, enhancing my skills.',
//       image: navyaImage,
//       buttonText: ' R Vishnu Vardhan',
//       extraText: '(SIMULATION ENGINEER)',
//       extraTexts: 'Got Placed At',
//     },
//     {
//       id: 2,
//       name: 'Flutter Developer',
//       rating: '★★★★★',
//       description: 'This course gave me the skills to develop apps for both Android and iOS seamlessly.',
//       image: arjunImage,
//       buttonText: 'Akhil Teli',
//       extraText: '(REACT.JS)',
//       extraTexts: 'Got Placed At',
//     },
//     {
//       id: 3,
//       name: 'Frontend Devloper',
//       rating: '★★★★★',
//       description: 'Great hands-on experience that sharpened my skills in HTML, CSS, and JavaScript.',
//       image: meeraImage,
//       buttonText: 'Naresh',
//       extraText: '(REACT.JS)',
//       extraTexts: 'Got Placed At',

//     },
//     {
//       id: 4,
//       name: 'Web Developer',
//       rating: '★★★★★',
//       description: 'A fantastic program that helped me build real-world front-end development skills.',
//       image: rahulImage2,
//       buttonText: 'Vikash Kumar Singh',
//       extraText: '(REACT.JS)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 5,
//       name: 'Virtual Robotics Simulation',
//       rating: '★★★★★',
//       description: 'I gained practical knowledge in robotics, making complex concepts easier to understand.',
//       image: rahulImage10,
//       buttonText: 'Shastrula Sreevasthsava',
//       extraText: '(ASSOCIATE ENGINEER)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 6,
//       name: 'Digital Factory',
//       rating: '★★★★★',
//       description: 'A great experience that enhanced my skills in designing efficient systems.',
//       image: rahulImage8,
//       buttonText: 'Chidura Samyuktha',
//       extraText: '(ASSOCIATE ENGINEER)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 7,
//       name: 'Virtual Robotics Simulation',
//       rating: '★★★★★',
//       description: 'The robotics projects were engaging and helped me visualize real-world systems.',
//       image: rahulImage7,
//       buttonText: 'K Lingeswarara Rao',
//       extraText: '(ASSOCIATE ENGINEER)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 8,
//       name: 'Banckend Developer',
//       rating: '★★★★★',
//       description: 'Hands-on experience with back-end technologies prepared me for real-world projects.',
//       image: rahulImage,
//       buttonText: 'D Ramachandra Reddy',
//       extraText: '(JAVA)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 9,
//       name: 'Frontend Developer',
//       rating: '★★★★★',
//       description: 'The training provided practical knowledge that’s directly applicable to web development projects.',
//       image: rahulImage1,
//       buttonText: 'Vikash Kumar ',
//       extraText: '(REACT.JS)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 10,
//       name: 'Tool& Fixture Design',
//       rating: '★★★★★',
//       description: 'Hands-on experience in tool design made all the difference – truly valuable!',
//       image: rahulImage3,
//       buttonText: 'P. Siva Nagaraju',
//       extraText: '(DESIGN ENGINEER)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 11,
//       name: 'Tool& Fixture Design',
//       rating: '★★★★★',
//       description: 'Excellent training that enhanced my understanding of the design process.',
//       image: rahulImage4,
//       buttonText: 'Eera Anvesh',
//       extraText: '(DESIGN ENGINEER)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 12,
//       name: 'Virtual Robotic Simulation',
//       rating: '★★★★★',
//       description: 'The program was an eye-opener, providing deep insights into robotics technology.',
//       image: rahulImage5,
//       buttonText: 'Prasanna Kumar Reddy',
//       extraText: '(SIMULATION ENGINEER)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 13,
//       name: 'Virtual Robotic Simulation',
//       rating: '★★★★★',
//       description: 'The robotics projects were engaging and helped me visualize real-world systems.',
//       image: rahulImage6,
//       buttonText: 'Wasiq Uddin',
//       extraText: '(SIMULATION ENGINEER)',
//       extraTexts: 'Got Placed At',
     

//     },
//     {
//       id: 14,
//       name: 'Digital Factory',
//       rating: '★★★★★',
//       description: 'Excellent hands-on training that helped me understand cutting-edge solutions.',
//       image: rahulImage9,
//       buttonText: 'Saranya Balaka',
//       extraText: '(ASSOCIATE ENGINEER)',
//       extraTexts: 'Got Placed At',
     
//     },

//   ];

//   const styles = {
//     title: {
//       textAlign: 'center',
//       fontFamily: 'auto,',
//       fontWeight: 700,
//       fontSize: '48px',
//       marginBottom: '31px',
//     },
//     titleBlack: {
//       color: 'black',
//     },
//     titleOrange: {
//       color: 'orange',
//     },
//     cardContainer: {
//       width:' 50% !important;',
//       display: 'flex',
//       flexWrap: 'nowrap',
//       overflow: 'hidden',
//       position: 'relative',
//       marginRight: '20px',
      
//     },
//     cardWrapper: {
//       display: 'flex',
//       transition: 'transform 0.5s ease-in-out',
//     },
   
//       card: {
//         position: 'relative',
//         width:' 50% !important;', // Reduced the width to reduce space between cards
//         height: '10px',
//         borderRadius: '100px',
//         overflow: 'hidden',
//         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//         textAlign: 'center',
//         transition: 'transform 0.3s ease',
//         display: 'flex',
//         flexDirection: 'column',
       
//       }, // Adjust the width as needed
     
//     image: {
//       position: 'absolute',
//       left: '0px',
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//       transition: 'all 0.3s ease',
//       top: '-45px',
//     },
//     imageCircle: {
//       top: '20px',
//       left: '20px',
//       width: '100px',
//       height: '100px',
//       objectFit: 'cover',
//       borderRadius: '50%',
//       transition: 'all 0.3s ease',
//       border: '8px solid orange',
//     },
//     button: {
//       position: 'absolute',
//       bottom: '-1px',
//       left: '50%',
//       width: '100%',
//       height: '80px',
//       borderRadius: '40px',
//       transform: 'translateX(-50%)',
//       padding: '10px 20px',
//       backgroundColor: 'rgb(0 0 255)',
//       color: 'white',
//       border: 'none',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//     },
//     buttonHover: {
//       // backgroundColor: 'orange',
//       // height: '250px',
//       // borderRadius: '50px',
//     },
//     cardContent: {
//       position: 'absolute',
//       top: '50%',
//       // marginRight: '20px',
//       width: '100%',
//       height: '600px',
//       backgroundColor: 'rgb(0 0 255)',
//       color: 'white',
//       padding: '10px',
//       borderRadius: '50px',
//       opacity: '0',
//       transform: 'translateY(20px)',
//       transition: 'opacity 0.3s ease, transform 0.3s ease, height 0.3s ease',
//       textAlign: 'center',
//     },
//     cardContentVisible: {
//       opacity: '1',
//       transform: 'translateY(0)',
//     },
//     name: {
//       fontWeight: 'bold',
//       fontSize: '18px',
//     },
//     rating: {
//       color: 'gold',
//       margin: '5px 0',
//     },
//     description: {
//       fontSize: '17px',
//       color: 'orange',
//     },
//     textWithLogo: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       marginTop: '10px',
//     },
//     smallText: {
//       fontSize: '20px',
//       fontWeight: '700',
//       color: 'black',
//       fontFamily: 'roboto',
//     },
//     smallLogo: {
//       width: '150px',
//       height: '30px',
//       marginRight: '-15px',
//     },
//     navButton: {
//       position: 'absolute',
//       top: '50%',
//       zIndex: '10',
//       background: 'transparent',
//       border: 'none',
//       cursor: 'pointer',
//       color: 'rgb(0 0 255)',
//       fontSize: '30px',
//     },
//     prevButton: {
//       left: '10px',
//       transform: 'translateY(-50%)',
//     },
//     nextButton: {
//       right: '10px',
//       transform: 'translateY(-50%)',
//     },
//   }
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const settings = {
//     dots: false, // Enable dots for pagination
//     infinite: true, // Infinite loop
//     speed: 500, // Transition speed
//     slidesToShow: 3, // Show 3 slides at a time
//     slidesToScroll: 1, // Scroll 1 slide at a time
//     nextArrow: (
//       <div style={{
//         position: 'absolute',
//         top: '50%',
//         right: '10px',
//         transform: 'translateY(-50%)',
//         backgroundColor: '#215a9d',
//         border: 'none',
//         borderRadius: '50%',
//         width: '50px',
//         height: '50px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         color: 'white',
//         cursor: 'pointer',
//       }}>
//         <FaArrowRight size={24} />
//       </div>
//     ),
//     prevArrow: (
//       <div style={{
//         position: 'absolute',
//         top: '50%',
//         left: '10px',
//         transform: 'translateY(-50%)',
//         backgroundColor: '#215a9d',
//         border: 'none',
//         borderRadius: '50%',
//         width: '50px',
//         height: '50px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         color: 'white',
//         cursor: 'pointer',
//       }}>
//         <FaArrowLeft size={24} />
//       </div>
//     ),
//     responsive: [
//       {
//         breakpoint: 1024, // Adjust settings for screens smaller than 1024px
//         settings: {
//           slidesToShow: 2, // Show 2 slides for medium screens
//         },
//       },
//       {
//         breakpoint: 600, // Adjust settings for screens smaller than 600px
//         settings: {
//           slidesToShow: 1, // Show 1 slide for smaller screens
//         },
//       },
//     ],
//   };

//   return (
//     <div>
//       <h1 style={{ textAlign: 'center', fontFamily: 'auto', fontWeight: 700, fontSize: '48px', marginBottom: '31px' }}>
//         <span style={{ color: 'black' }}>What Our</span>{' '}
//         <span style={{ color: 'orange' }}>Learner`s Say</span>
//       </h1>

//       <Slider {...settings}>
//         {cards.map((card) => (
//           <div key={card.id} style={{  width:' 50% !important;' }} onMouseEnter={() => setHoveredCard(card.id)}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div className="circlecard-hover"
//               style={{
//                 position: 'relative',
//                 width: '405px',
//                 height: '450px',
//                 borderRadius: '40px',
//                 overflow: 'hidden',
//                 boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//                 textAlign: 'center',
//                 margin: '0 auto',
//               }}
//             >
//               {/* Image */}
//               <img
//                 src={card.image}
//                 alt={`card-${card.id}`}
//                 style={hoveredCard === card.id ? styles.imageCircle : styles.image}

//               />

//               {/* Button */}
//               <button
//                 style={{
//                   ...styles.button,
//                   ...(hoveredCard === card.id ? styles.buttonHover : {}),

//                 }}
//               >
//                 {card.buttonText}
//                 <br></br>  <br></br>
//                 {card.extraText}
//               </button>
//               <div style={{ ...styles.textWithLogo, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//   <span style={styles.smallText}>
//     {card.extraTexts}
//   </span>
//   <img
//     src={logoImage} // Replace with the actual logo path
//     alt="logo"
//     style={styles.smallLogo}
//   />
// </div>


//               {/* Content (Hidden by default) */}
//               <div
//                 style={{
//                   ...styles.cardContent,
//                   ...(hoveredCard === card.id ? styles.cardContentVisible : {}),
//                 }}

//               >
//                 <div style={{ fontWeight: 'bold', fontSize: '18px' }}>{card.name}</div>
//                 <div style={{ color: 'gold', margin: '5px 0' }}>{card.rating}</div>
//                 <div style={{ fontSize: '17px', color: 'orange' }}>{card.description}</div>
//               </div>
//             </div>
//           </div>
//         ))}



//       </Slider>
//       <style>{`
  

//   @media (max-width: 768px) {
//     . nextArrow{
//       display: none;
//     }
//       . prevArrow{
//       display: none;
//       }
//   }
// `}</style>

//     </div>
    
//   );
// };

// export default CardComponent;








// import React, { useEffect, useRef } from 'react';
// import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import img3 from '../img/aaaservices/12_SARANYA.jpg';
// import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';

// import navyaImage from '../img/aaaservices/WhatsApp Image 2024-12-27 at 4.19.57 PM.jpeg';
// import arjunImage from '../img/aaaservices/Akhil.jfif';
// import meeraImage from '../img/banner/01_NARESH_FRONTEND DEVELOPER.jpeg';
// import rahulImage from '../img/aaaservices/03_RAMACHANDRA_BACKEND DEVELOPER.jpeg';
// import rahulImage1 from '../img/aaaservices/04_VIKASH_WEB DEVELOPER.jpeg';
// import rahulImage2 from '../img/aaaservices/05_VIKASH SINGH_WEB DEVELOPER.jpeg';
// import rahulImage3 from '../img/aaaservices/01_SHIVA.jpeg';
// import rahulImage4 from '../img/aaaservices/02_ANVESH.jpeg';
// import rahulImage5 from '../img/aaaservices/03_PRASANNA.jpeg';
// import rahulImage6 from '../img/aaaservices/04_WASIQ.jpeg';

//  import logoImage from '../img/banner/Picture2.png';


// const CoachProfiles = () => {
//   const carouselRef = useRef(null);

  


//   const coaches = [
//   {
//     name: "G. Lokesh",
//     title: "Automation Training Specialist",
//     image: img1,
//     backText: "Expert in Automation",
//     description: "Trained 500+ students in industrial automation.",
//     logo: logoImage,
//   },
//   {
//     name: "Riyaz Uddin",
//     title: "Subject Matter Expert",
//     image: img2,
//     backText: "SME for Automation",
//     description: "Hands-on trainer in automation tools.",
//     logo: logoImage,
//   },
//   {
//     name: "SARANYA",
//     title: "Automation Training Specialist",
//     image: img3,
//     backText: "Certified Trainer",
//     description: "Industry-recognized certification holder.",
//     logo: logoImage,
//   },
//   {
//     name: "MD. Ghouse",
//     title: "Technical Trainer",
//     image: img4,
//     backText: "Experienced Technical Trainer",
//     description: "5+ years in technical education delivery.",
//     logo: logoImage,
//   },
//   {
//     name: "Navya",
//     title: "Trainer",
//     image: navyaImage,
//     backText: "Specialist in Java",
//     description: "Focused on full-stack Java technologies.",
//     logo: logoImage,
//   },
//   {
//     name: "Arjun",
//     title: "Developer",
//     image: arjunImage,
//     backText: "Full-stack Developer",
//     description: "Experienced in MERN stack development.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Meera",
//     title: "Frontend Developer",
//     image: meeraImage,
//     backText: "React Specialist",
//     description: "Expert in modern frontend frameworks.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Rahul Ramachandra",
//     title: "Backend Developer",
//     image: rahulImage,
//     backText: "Node.js Expert",
//     description: "Specialist in server-side solutions.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Vikash Web Dev 1",
//     title: "Web Developer",
//     image: rahulImage1,
//     backText: "Web Apps Developer",
//     description: "Built scalable web applications.",
//     eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Vikash Singh",
//     title: "Web Developer",
//     image: rahulImage2,
//     backText: "Frontend Expert",
//     description: "HTML, CSS, JS and React proficiency.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Shiva",
//     title: "Trainer",
//     image: rahulImage3,
//     backText: "IT Trainer",
//     description: "Delivered workshops on IT tools.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Anvesh",
//     title: "Technical Expert",
//     image: rahulImage4,
//     backText: "Automation Expert",
//     description: "Worked with industrial automation teams.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Prasanna",
//     title: "Trainer",
//     image: rahulImage5,
//     backText: "Tech Trainer",
//     description: "Effective communicator and coach.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   },
//   {
//     name: "Wasiq",
//     title: "Technical Lead",
//     image: rahulImage6,
//     backText: "Team Lead",
//     description: "Leads training and mentoring sessions.",
//      eperttext:'Got Placed At',
//     logo: logoImage,
//   }
// ];


//   useEffect(() => {
//     const carousel = carouselRef.current;
//     let scrollAmount = 0;
//     const speed = 1; // px per frame

//     let animationFrameId;

//     const step = () => {
//       if (!carousel) return;

//       scrollAmount += speed;
//       if (scrollAmount >= carousel.scrollWidth / 2) {
//         scrollAmount = 0;
//       }
//       carousel.scrollLeft = scrollAmount;
//       animationFrameId = requestAnimationFrame(step);
//     };

//     animationFrameId = requestAnimationFrame(step);

//     return () => cancelAnimationFrame(animationFrameId);
//   }, []);

//   const displayCoaches = [...coaches, ...coaches];

//   return (
//     <>
//       <style>{`
//         .carousel {
//   display: flex;
//   overflow-x: hidden;
//   gap: 30px;

//   user-select: none;
//   cursor: grab;
//   width: 100%;
//   margin: auto;
//   max-width:1400px;
// }

// .card-logo {
//   width: 100px;
//   height: 100px;
//   object-fit: contain;
//   margin-top: 10px;
//   display: block;
// }


//         .card {
//           width: 280px;
//           height: 320px;
//           perspective: 1000px;
//           flex: 0 0 auto;
//         }
//         .card-inner {
//           position: relative;
//           width: 100%;
//           height: 100%;
//           text-align: center;
//           transition: transform 0.8s;
//           transform-style: preserve-3d;
//         }
//         .card:hover .card-inner {
//           transform: rotateY(180deg);
//           cursor: pointer;
//         }
//         .card-front, .card-back {
//           position: absolute;
//           width: 100%;
//           height: 100%;
//           border-radius: 12px;
//           box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//           backface-visibility: hidden;
//           overflow: hidden;
//         }
//         .card-front img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//           pointer-events: none;
//         }
//         .card-front .info {
//           position: absolute;
//           bottom: 0;
//           width: 100%;
//           background: rgba(0,0,0,0.6);
//           color: white;
//           padding: 12px 15px;
//         }
//         .card-front .info h3 {
//           margin: 0;
//           color: orange;
//           font-size: 20px;
//         }
//         .card-front .info p {
//           margin: 0;
//           font-size: 14px;
//           font-weight: normal;
//         }
//         .card-back {
//           background: #f9f9f9;
//           color: #333;
//           transform: rotateY(180deg);
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//           box-shadow: 0 4px 8px rgba(0,0,0,0.15);
//         }
//         .card-back p {
//           font-size: 16px;
//           margin-bottom: 20px;
//         }
//         .card-back button {
//           background: orange;
          
//           color: white;
//           padding: 10px 18px;
//           border-radius: 6px;
//           font-size: 14px;
//           cursor: pointer;
//           transition: background 0.3s ease;
//         }
//         .card-back button:hover {
//           background: darkorange;
//         }


        
//       `}</style>

//       <div style={{ background: 'white', padding: '40px 0' }}>
//         <p style={{
//           textAlign: 'center',
//           fontSize: '48px',
//           fontWeight: 'bold',
//           margin: '20px 0',
//           fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif'
//         }}>
//           <span style={{ color: 'rgb(0, 87, 200)' }}>Our </span>
//           <span style={{ color: 'rgb(247 148 29)' }}>learners</span>
//         </p>

//         <div ref={carouselRef} className="carousel">
//           {displayCoaches.map((coach, i) => (
//             <div className="card" key={i}>
//               <div className="card-inner">
//                 <div className="card-front">
//                   <img src={coach.image} alt={coach.name} draggable={false} />
//                   <div className="info">
//                     <h3>{coach.name}</h3>
//                     <p>{coach.title}</p>
                    
//                   </div>
//                 </div>
//                 <div className="card-back">
//                   <p>{coach.backText}</p>
//                   <p>{coach.description}</p>
//                    <p>{coach.eperttext}</p>
//       <img src={coach.logo} alt="Logo" className="card-logo" />
//                   {/* <button>Know More</button> */}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default CoachProfiles;

// import React, { useEffect, useRef } from 'react';
// import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
// import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
// import img3 from '../img/aaaservices/12_SARANYA.jpg';
// import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';

// import navyaImage from '../img/aaaservices/WhatsApp Image 2024-12-27 at 4.19.57 PM.jpeg';
// import arjunImage from '../img/aaaservices/Akhil.jfif';
// import meeraImage from '../img/banner/01_NARESH_FRONTEND DEVELOPER.jpeg';
// import rahulImage from '../img/aaaservices/03_RAMACHANDRA_BACKEND DEVELOPER.jpeg';
// import rahulImage1 from '../img/aaaservices/04_VIKASH_WEB DEVELOPER.jpeg';
// import rahulImage2 from '../img/aaaservices/05_VIKASH SINGH_WEB DEVELOPER.jpeg';
// import rahulImage3 from '../img/aaaservices/01_SHIVA.jpeg';
// import rahulImage4 from '../img/aaaservices/02_ANVESH.jpeg';
// import rahulImage5 from '../img/aaaservices/03_PRASANNA.jpeg';
// import rahulImage6 from '../img/aaaservices/04_WASIQ.jpeg';

// import logoImage from '../img/banner/Picture2.png';

// const CoachProfiles = () => {
//   const carouselRef = useRef(null);

//   const coaches = [
//     { name: "G. Lokesh", title: "Automation Training Specialist", image: img1, backText: "Expert in Automation", description: "Trained 500+ students in industrial automation.", logo: logoImage },
//     { name: "Riyaz Uddin", title: "Subject Matter Expert", image: img2, backText: "SME for Automation", description: "Hands-on trainer in automation tools.", logo: logoImage },
//     { name: "SARANYA", title: "Automation Training Specialist", image: img3, backText: "Certified Trainer", description: "Industry-recognized certification holder.", logo: logoImage },
//     { name: "MD. Ghouse", title: "Technical Trainer", image: img4, backText: "Experienced Technical Trainer", description: "5+ years in technical education delivery.", logo: logoImage },
//     { name: "Navya", title: "Trainer", image: navyaImage, backText: "Specialist in Java", description: "Focused on full-stack Java technologies.", logo: logoImage },
//     { name: "Arjun", title: "Developer", image: arjunImage, backText: "Full-stack Developer", description: "Experienced in MERN stack development.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Meera", title: "Frontend Developer", image: meeraImage, backText: "React Specialist", description: "Expert in modern frontend frameworks.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Rahul Ramachandra", title: "Backend Developer", image: rahulImage, backText: "Node.js Expert", description: "Specialist in server-side solutions.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Vikash Web Dev 1", title: "Web Developer", image: rahulImage1, backText: "Web Apps Developer", description: "Built scalable web applications.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Vikash Singh", title: "Web Developer", image: rahulImage2, backText: "Frontend Expert", description: "HTML, CSS, JS and React proficiency.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Shiva", title: "Trainer", image: rahulImage3, backText: "IT Trainer", description: "Delivered workshops on IT tools.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Anvesh", title: "Technical Expert", image: rahulImage4, backText: "Automation Expert", description: "Worked with industrial automation teams.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Prasanna", title: "Trainer", image: rahulImage5, backText: "Tech Trainer", description: "Effective communicator and coach.", eperttext: 'Got Placed At', logo: logoImage },
//     { name: "Wasiq", title: "Technical Lead", image: rahulImage6, backText: "Team Lead", description: "Leads training and mentoring sessions.", eperttext: 'Got Placed At', logo: logoImage }
//   ];

//   useEffect(() => {
//     const carousel = carouselRef.current;
//     let scrollAmount = 0;
//     const speed = 1;
//     let animationFrameId;

//     const step = () => {
//       if (!carousel) return;
//       scrollAmount += speed;
//       if (scrollAmount >= carousel.scrollWidth / 2) {
//         scrollAmount = 0;
//       }
//       carousel.scrollLeft = scrollAmount;
//       animationFrameId = requestAnimationFrame(step);
//     };

//     animationFrameId = requestAnimationFrame(step);
//     return () => cancelAnimationFrame(animationFrameId);
//   }, []);

//   const displayCoaches = [...coaches, ...coaches];

//   return (
//     <>
//       <style>{`
//         .carousel {
//           display: flex;
//           overflow-x: hidden;
//           gap: 30px;
//           user-select: none;
//           cursor: grab;
//           width: 100%;
//           margin: auto;
//           max-width: 1400px;
          
//         }

//         .card {
//           width: 280px;
//           height: 320px;
//           position: relative;
//           flex: 0 0 auto;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 4px 10px rgba(0,0,0,0.1);
//         }

//         .card img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           display: block;
//         }

//         .card-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: rgba(0,0,0,0.7);
//           color: #fff;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           padding: 15px;
//           opacity: 0;
//           transition: opacity 0.4s ease-in-out;
//           text-align: center;
//         }

//         .card:hover .card-overlay {
//           opacity: 1;
//         }

//         .card-overlay h3 {
//           margin: 5px 0;
//           font-size: 20px;
//           color: orange;
//         }

//         .card-overlay p {
//           margin: 5px 0;
//           font-size: 14px;
//         }

//         .card-logo {
//           width: 30px;
//           height: 30px;
//           object-fit: contain;
//           margin-top: 10px;
//         }
//       `}</style>

//       <div style={{ background: 'blue', padding: '40px 0' }}>
//         <p style={{
//           textAlign: 'center',
//           fontSize: '48px',
//           fontWeight: 'bold',
//           margin: '20px 0',
//           fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif'
//         }}>
//           <span style={{ color: 'white' }}>Our </span>
//           <span style={{ color: 'rgb(247 148 29)' }}>learners</span>
//         </p>

//         <div ref={carouselRef} className="carousel">
//           {displayCoaches.map((coach, i) => (
//             <div className="card" key={i}>
//               <img src={coach.image} alt={coach.name} />
//               <div className="card-overlay">
//                 <h3>{coach.name}</h3>
//                 <p>{coach.title}</p>
//                 <p>{coach.backText}</p>
//                 <p>{coach.description}</p>
//                 {coach.eperttext && <p>{coach.eperttext}</p>}
//                 {coach.logo && <img src={coach.logo} alt="Logo" style={{width:'80px',height:'80px',objectFit:"contain",marginTop:'10px'}} />}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default CoachProfiles;






import React, { useEffect, useRef } from 'react';
import img1 from '../img/logo/New folder/IMG-20241127-WA0001.jpg';
import img2 from '../img/logo/New folder/IMG-20241127-WA0003.jpg';
import img3 from '../img/aaaservices/12_SARANYA.jpg';
import img4 from '../img/logo/New folder/IMG-20241127-WA0002 (1).jpg';

import naveen from '../img/aaaservices/navven.jpg';
import pchnanda from '../img/aaaservices/chandbasa.jpg';
import subryamnanyam from '../img/aaaservices/subramnyam.jpg';
import meeraImage from '../img/aaaservices/Nareshsir.jpg';
import Navaneeth from '../img/aaaservices/nawneet.jpg';
import rahulImage1 from '../img/aaaservices/SAVE_20230519_121324.jpg.jpeg';
import rahulImage2 from '../img/aaaservices/vikash.png';
import rahulImage3 from '../img/aaaservices/mahesh.jpg';
import rahulImage4 from '../img/aaaservices/vamshi.jpeg';
import rahulImage5 from '../img/aaaservices/satish.jpg';
import rahulImage6 from '../img/aaaservices/nagorg.jpg';
import sudheer from '../img/aaaservices/sudheer.jpg'
import avishek from '../img/aaaservices/avishek.jpg'

import logoImage from '../img/banner/Picture2.png';

const coaches = [
 {
  name: "Naveen",
  title: "Mechanical Engineer",
  subheading: "Improved my practical skills through hands-on mechanical projects.",
  image: naveen,
},
{
  name: "P. Chand Basha",
  title: "Mechanical Engineer",
  subheading: "Great learning environment with strong focus on real-world applications.",
  image: pchnanda,
},
{
  name: "Subramanyam",
  title: "Mechanical Engineer",
  subheading: "Helped me build confidence in industrial tools and techniques.",
  image: subryamnanyam,
},
{
  name: "Navaneeth",
  title: "Mechanical Design Engineer",
  subheading: "Enhanced my design skills with practical CAD and automation exposure.",
  image: Navaneeth,
},

  // Updated & New Entries
  {
    name: "Naresh Bojja",
    title: "Full-Stack Developer",
    subheading: "Skilled in both frontend and backend technologies.",
    image: meeraImage,
  },
  {
    name: "Vikash Singh",
    title: "Full-Stack Developer",
    subheading: "Experienced in building complete web applications.",
    image: rahulImage2,
  },
  {
    name: "Jai Sivapavan",
    title: "Web Developer",
    subheading: "Focused on creating responsive and user-friendly websites.",
    image: rahulImage1,
  },
  {
    name: "Mahesh Bonthala",
    title: "Flutter Developer",
    subheading: "Specialized in building cross-platform mobile applications.",
    image: rahulImage3,
  },
  {
    name: "VamshiKrishna Kukkala",
    title: "Backend Developer",
    subheading: "Experienced in server-side logic and database management.",
    image: rahulImage4,
  },
  {
    name: "Satish Ghanta",
    title: "Backend Developer",
    subheading: "Focused on scalable and efficient backend systems.",
    image: rahulImage5,
  },
  {
    name: "Koppula Nagaraj",
    title: "Flutter Developer",
    subheading: "Passionate about modern mobile app development.",
    image: rahulImage6,
  },
  {
    name: "Mulinti Abhishek",
    title: "Flutter Developer",
    subheading: "Experienced in building high-performance mobile apps.",
    image: avishek,
  },
  {
    name: "Goddumarri Sudheer Kumar",
    title: "Web Developer",
    subheading: "Focused on modern web technologies and UI development.",
    image: sudheer,
  },
];



const CoachProfiles = () => {
  const carouselRef = useRef(null);
  useEffect(() => {
    const carousel = carouselRef.current;
    let scrollAmount = 0;
    const speed = 1;
    let animationFrameId;

    const step = () => {
      if (!carousel) return;
      scrollAmount += speed;
      if (scrollAmount >= carousel.scrollWidth / 2) {
        scrollAmount = 0;
      }
      carousel.scrollLeft = scrollAmount;
      animationFrameId = requestAnimationFrame(step);
    };

    animationFrameId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  const displayCoaches = [...coaches, ...coaches];

  return (
    <div style={styles.wrapper}>
      <p style={{
          textAlign: 'center',
          fontSize: '48px',
          fontWeight: 'bold',
          margin: '8px 0',
          marginTop:'-30px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif'
        }}>
          <span style={{ color: 'white' }}>Our </span>
          <span style={{ color: 'rgb(247 148 29)' }}>learners</span>
        </p>

      <div ref={carouselRef} className="carousel">
        {displayCoaches.map((card, index) => (
          <div key={index} style={styles.card} className="card">
            <img src={card.image} alt={card.name} className="card-img" />
            <div className="text-overlay">
  <button className="info-button">
    <div className="info-header">
      <h3 style={{fontSize:'25px',color:'blue',fontFamily:'sans,serif'}}>{card.name}</h3>
      
        <p>{card.rating}</p>
      <p>{card.title}</p>
      <p style={{color:'blue',fontFamily:'sans,serif'}}>{card.subheading}</p>

    </div>
    <div className="info-details">
      <p  style={{color:'black',fontSize:'25px',fontFamily:'sans,serif'}}>Got Placed At</p>
     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '-20px' }}>
  <img src={logoImage} alt="logo" className="logo" />
</div>


    </div>
  </button>
</div>
</div>
        ))}
      </div>

      <style>{`

.carousel {
           display: flex;
           overflow-x: hidden;
           gap: 30px;
           user-select: none;
           cursor: grab;
           width: 100%;
           margin: auto;
           max-width: 1400px;
          
         }

       .card {
           width: 280px;
           height: 320px;
           position: relative;   
            flex: 0 0 auto;
          
           overflow: hidden;
           box-shadow: 0 4px 10px rgba(0,0,0,0.1);
         }

        .card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.5s ease;
          z-index: 1;
        }

        .text-overlay {
          position: absolute;
          bottom: 0;
          width: 100%;
            background: rgb(255, 255, 255);
          // background: rgba(0, 0, 0, 0.4); /* semi-transparent black */

          color: blue;
          text-align: center;

 border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;


         
          z-index: 2;
        }

        .card-content {
          position: absolute;
          bottom: 20px;
          left: 20px;
          right: 20px;
          opacity: 0;
          z-index: 3;
          transition: all 0.5s ease;
          // background: rgba(255,255,255,0.95);
          background: transparent;

          padding: 15px;
          border-radius: 10px;
        }

        .card:hover .card-img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          top: 20px;
          left: 20px;
          border:2px solid orange;
        }

        .card:hover .card-content {
          opacity: 1;
        }

       .info-button {
  background-color: transparent;
  border: 2px white;
  color: orange;
  width: 100%;
  padding: 10px;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.5s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  max-height: 60px;
}

.card:hover .info-button {
  max-height: 200px;
  padding: 20px 10px;
}

.info-header h3 {
  font-size: 16px;
  margin: 0;
  font-weight: bold;
}

.info-header p {
  font-size: 14px;
  margin: 2px 0;
}

.info-details {
  opacity: 0;
  transition: opacity 0.5s ease;
  text-align: center;
  margin-top: 10px;
}

.card:hover .info-details {
  opacity: 1;
}


.logo {
  width: 80px;
  height: 25px;
  margin-top: 5px;
}
      `}</style>
    </div>
  );
};

const styles = {
  wrapper: {
    overflow: 'hidden',
    padding: '20px',
    backgroundColor:'blue'
  },
  slider: {
    display: 'flex',
    gap: '20px',
    width: 'max-content',
  },
  card: {
    width: '300px',
    height: '320px',
    backgroundColor: '#fff',
    borderRadius: '15px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    position: 'relative',
    
  },
};

export default CoachProfiles;

